import { Box, Typography, Button, Stack, Avatar, Paper } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { FadeIn } from '../../ui/FadeIn';

export function FounderStory() {
    return (
        <Box sx={{ py: 10 }}>
            <FadeIn>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center',
                        gap: 6,
                        maxWidth: 1000,
                        mx: 'auto'
                    }}
                >
                    <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="overline" color="primary" sx={{ fontWeight: 700, letterSpacing: 1 }}>
                            Our Story
                        </Typography>
                        <Typography variant="h3" fontWeight={700} gutterBottom sx={{ mt: 1 }}>
                            Built by survivors, for survivors.
                        </Typography>
                        <Typography variant="body1" color="text.secondary" paragraph sx={{ fontSize: '1.1rem', mb: 3 }}>
                            Neumind wasn't built in a boardroom. It was born from the lived experience of identical twins, Luke and Ellis. After a life-changing brain injury, they realized the tools for life-long recovery didn't exist. So they built them.
                        </Typography>
                        <Button
                            component={Link}
                            to="/about"
                            variant="outlined"
                            size="large"
                            sx={{
                                borderRadius: 50,
                                textTransform: 'none',
                                px: 4,
                                borderColor: 'divider',
                                color: 'text.primary',
                                '&:hover': {
                                    borderColor: 'primary.main',
                                    color: 'primary.main',
                                    bgcolor: 'transparent'
                                }
                            }}
                        >
                            Read Luke & Ellis's story
                        </Button>
                    </Box>

                    <Box sx={{ flex: 1, position: 'relative' }}>
                        <Box
                            component="img"
                            src="/assets/ellis-headshot-DbXRcIpe.png" // Placeholder or reuse existing if available in assets
                            // Ideally use the correct path if known, defaulting to generic layout
                            sx={{
                                width: '100%',
                                maxWidth: 400,
                                borderRadius: 4,
                                boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)',
                                display: 'none' // Hide image if asset not guaranteed, or replace with Quote card
                            }}
                        />
                        <Paper
                            elevation={0}
                            sx={{
                                p: 4,
                                borderRadius: 4,
                                bgcolor: 'white',
                                border: '1px solid',
                                borderColor: 'divider',
                                position: 'relative',
                                '&::before': {
                                    content: '"“"',
                                    position: 'absolute',
                                    top: 20,
                                    left: 20,
                                    fontSize: '4rem',
                                    lineHeight: 1,
                                    color: 'primary.light',
                                    opacity: 0.2,
                                    fontFamily: 'serif'
                                }
                            }}
                        >
                            <Typography variant="h6" sx={{ fontStyle: 'italic', mb: 2, fontWeight: 500, position: 'relative', zIndex: 1 }}>
                                "The app is a lifesaver! I use Neumind for reminders about medication and hospital appointments. But I also try to balance it out with fun things as well to remind me to meet friends for a coffee."
                            </Typography>
                            <Stack direction="row" alignItems="center" spacing={2} mt={3}>
                                <Avatar sx={{ bgcolor: 'primary.main' }}>C</Avatar>
                                <Box>
                                    <Typography variant="subtitle2" fontWeight={700}>
                                        Calhan
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Brain Injury Survivor
                                    </Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    </Box>
                </Box>
            </FadeIn>
        </Box>
    );
}


